// src/encounter/services/use-save-occupation.ts
// Rail-scoped save hook for the Occupation card (PROD-1272). PUT /api/Patients/PatientOccupation/{patientId}
// (upsert — Flutter patient_data_source_impl.dart:467) and invalidate the patient-detail query
// (['patient-detail', patientId]) — the rail's Occupation/Education render source (PROD-1270), so a
// fresh save re-renders without reload. Transport + cache only; body shape lives in
// lib/to-occupation-request.ts.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { put } from '@/shared/api/api-client';
import type { OccupationRequest } from '@/encounter/lib/to-occupation-request';

export function useSaveOccupation(patientId: string | undefined) {
  const qc = useQueryClient();
  return useMutation<string, Error, OccupationRequest>({
    mutationFn: (req: OccupationRequest) =>
      put<string>(`/api/Patients/PatientOccupation/${req.patientId}`, req.body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['patient-detail', patientId] });
    },
  });
}
